module.exports = __webpack_public_path__ + "img/boy_010024.7f0ea45b.png";